import { useMemo } from 'react';
import { Typography } from '@mui/material';

import type { WalletInfo } from 'src/types/wallet';

import { Base02TextContainer, Container, LeftContainer, TextColumnContainer } from './styled';

import { ReactComponent as CosmostationWalletIcon } from 'src/assets/svg/CosmostationWallet.svg';
import { ReactComponent as MetamaskWalletIcon } from 'src/assets/svg/Metamask.svg';
import { ReactComponent as RightChevronIcon } from 'src/assets/svg/RightChevron.svg';

type WalletItemProps = {
  walletInfo: WalletInfo;
  onClick?: (walletInfo: WalletInfo) => void;
};

export default function WalletItem({ walletInfo, onClick }: WalletItemProps) {
  const walletIcon = useMemo(() => (walletInfo.name === 'Cosmostation' ? <CosmostationWalletIcon /> : <MetamaskWalletIcon />), [walletInfo.name]);

  const storeURL = useMemo(
    () =>
      walletInfo.walletType === 'Cosmostation'
        ? 'https://chrome.google.com/webstore/detail/cosmostation-wallet/fpkhgmpbidmiogeglndfbkegfdlnajnf'
        : 'https://chromewebstore.google.com/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?utm_source=metamask.io',
    [walletInfo.walletType],
  );
  return (
    <Container
      onClick={() => {
        if (!walletInfo.isInstalled) {
          window.open(storeURL);
        } else {
          onClick?.(walletInfo);
        }
      }}
      data-is-onclick={onClick ? 1 : 0}
    >
      <LeftContainer>
        {walletIcon}
        <TextColumnContainer>
          <Typography variant="h4">{walletInfo.name}</Typography>
          <Base02TextContainer>
            <Typography variant="h7">{walletInfo.description}</Typography>
          </Base02TextContainer>
        </TextColumnContainer>
      </LeftContainer>
      <RightChevronIcon />
    </Container>
  );
}
